import { memo, useEffect, useState, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";

import "./css/new_question.css";

import { AppContext } from "../../Context";
import Popups from "../../components/Popups";
import {
    Input,
    MultiSelect,
    ImageUpload,
    RichText,
    Options,
    ListOptions,
} from "../../components/Form";
import { Config } from "../../inc/Config";

import Fetch, { Loader } from "../../inc/Fetch";

export default function QuestionAdd({ setOpen, Open, setquestions }) {
    const { t } = useTranslation();
    const { successData, userinfo, options } = useContext(AppContext);
    const [open, setopen] = successData;
    // const [open, setopen] = successData;

    const [pageLoader, setpageLoader] = useState(true);
    const [loader, setloader] = useState(false);
    const [step, setstep] = useState(1);
    const [tab, settab] = useState(Open?.type || 1);

    const [id, setid] = useState(false);
    const [question, setquestion] = useState(Open?.question);
    const [answers, setanswers] = useState(Open?.answers);

    const types = [
        {
            name: t("task_answer_1"),
            val: 1,
        },
        {
            name: t("task_answer_2"),
            val: 2,
        },
        {
            name: t("task_answer_3"),
            val: 3,
        },
        {
            name: t("task_answer_4"),
            val: 4,
        },
        {
            name: t("task_answer_5"),
            val: 5,
        },
        {
            name: t("task_answer_6"),
            val: 6,
        },
    ];

    function submit() {
        if (tab == 1) {
            if (!answers?.text) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[9],
                });
                return false;
            }
        }

        if (tab == 2 || tab == 3 || tab == 4) {
            if (answers?.length < 2) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[10],
                });
                return false;
            }

            let ck = answers?.filter((p) => p?.checked);
            if (!ck?.length) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[11],
                });
                return false;
            }
        }

        if (tab == 5) {
            if (!answers) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[15],
                });
                return false;
            }

            if (answers?.length < 20) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[15],
                });
                return false;
            }

            if (answers?.length && answers?.indexOf("<inp>") == -1) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[16],
                });
                return false;
            }
        }

        // setquestions(p => p ? [...p, { question: question, answers:answers, type:tab, id:id }] : [{ question: question, answers:answers, type:tab, id:id }]);
        setquestions((p) => {
            let arr = [];

            p?.map((v) => {
                if (Open?.id == v?.id) {
                    arr.push({
                        question: question,
                        answers: answers,
                        type: tab,
                        id: Open?.id,
                    });
                } else {
                    arr.push(v);
                }
            });

            if (!Open?.id) {
                arr.push({
                    question: question,
                    answers: answers,
                    type: tab,
                    id: id,
                });
            }

            return arr;
        });

        setOpen(false);
    }

    function checkSteps(d) {
        if (d == 2) {
            if (!question) {
                setopen({
                    error: true,
                    short: t("error", { returnObjects: true })[8],
                });
                return false;
            }
        }

        setstep(d);
    }

    useEffect(() => {
        if (!id) {
            setid(Date.now());
        }

        // if (Open?.answers){
        //     setanswers(Open?.answers);

        // }
        setpageLoader(false);
        // setTimeout(() => {
        //     setpageLoader(false);
        // }, 100);
    }, []);

    if (pageLoader) {
        return <Loader />;
    }

    // console.log(answers);

    return (
        <>
            {loader && <Loader />}
            <Popups setOpen={setOpen} className="addQuestions" index={18}>
                <>
                    <div className="popupBody interface data">
                        <h2>{t("task_new_questions")}</h2>

                        <div
                            className={`questionBoxAns ${step == 1 && "show"}`}
                        >
                            <nav className="tab">
                                <a className={"ck"}>{t("task_question")}</a>
                            </nav>

                            <div className="questionsTypesAdd">
                                <RichText
                                    toolbar="bold italic forecolor styles | bullist numlist removeformat video imgs mp3"
                                    height={300}
                                    onChange={(r) => setquestion(r)}
                                    value={question}
                                />

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        gap: 5,
                                    }}
                                >
                                    <button
                                        onClick={() => checkSteps(2)}
                                        className="btn"
                                    >
                                        {t("next")}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div
                            className={`questionBoxAns ${step == 2 && "show"}`}
                        >
                            <nav className="tab">
                                {!Open?.type ? (
                                    types?.map((v, k) => {
                                        return (
                                            <a
                                                key={k}
                                                onClick={() => settab(v?.val)}
                                                className={
                                                    tab == v?.val
                                                        ? "ck"
                                                        : "false"
                                                }
                                            >
                                                {v?.name}
                                            </a>
                                        );
                                    })
                                ) : (
                                    <a className="ck">
                                        {t(`task_answer_${Open?.type}`)}
                                    </a>
                                )}
                            </nav>

                            {tab == 1 && (
                                <div className={`questionsBox show`}>
                                    <label class="formInputBox focused">
                                        <span>{t("task_right_answer")}</span>
                                        <textarea
                                            onChange={(r) =>
                                                setanswers({
                                                    text: r?.target?.value,
                                                })
                                            }
                                            name="textanser"
                                            value={answers?.text || ""}
                                        >
                                            {answers?.text || ""}
                                        </textarea>
                                    </label>
                                </div>
                            )}

                            {tab == 2 && (
                                <div className={`questionsBox show`}>
                                    <h4>
                                        <b>{t("task_note")}:</b>{" "}
                                        {t("task_note_sub_1")}
                                    </h4>

                                    <ListOptions
                                        data={answers?.length ? answers : []}
                                        type="radio"
                                        onChange={(d) => setanswers(d)}
                                        accept="image/png, image/jpeg, .mp3,audio/*"
                                    />
                                </div>
                            )}

                            {tab == 3 && (
                                <div className={`questionsBox show`}>
                                    <h4>
                                        <b>{t("task_note")}:</b>{" "}
                                        {t("task_note_sub_2")}
                                    </h4>

                                    <ListOptions
                                        data={answers?.length ? answers : []}
                                        type="checkbox"
                                        onChange={(d) => setanswers(d)}
                                    />
                                </div>
                            )}

                            {tab == 4 && (
                                <div className={`questionsBox show`}>
                                    <h4>
                                        <b>{t("task_note")}:</b>{" "}
                                        {t("task_note_sub_1")}
                                    </h4>

                                    <ListOptions
                                        data={answers?.length ? answers : []}
                                        type="radio"
                                        onChange={(d) => setanswers(d)}
                                        imgs={"no-images"}
                                    />
                                </div>
                            )}

                            {tab == 5 && (
                                <div className={`questionsBox show`}>
                                    <h4>
                                        <b>{t("task_note")}:</b>{" "}
                                        {t("task_note_sub_5")}
                                    </h4>

                                    <RichText
                                        toolbar="bold italic forecolor | bullist numlist code | media imgs mp3 textField"
                                        height={300}
                                        onChange={(r) =>
                                            setanswers({ text: r })
                                        }
                                        value={answers?.text || ""}
                                    />
                                </div>
                            )}

                            {tab == 6 && (
                                <div className={`questionsBox show`}>
                                    <h4>
                                        <b></b>
                                    </h4>

                                    <RichText
                                        toolbar="bold italic forecolor | bullist numlist code | media imgs mp3 math"
                                        height={300}
                                        onChange={(r) =>
                                            setanswers({ math: r })
                                        }
                                        value={answers?.math || ""}
                                    />
                                </div>
                            )}

                            <div
                                className="questionsTypesAdd"
                                style={{ padding: "0 20px 20px 20px" }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        gap: 5,
                                    }}
                                >
                                    <button
                                        onClick={() => checkSteps(1)}
                                        className="btn gray"
                                    >
                                        {t("prev")}
                                    </button>
                                    <button onClick={submit} className="btn">
                                        {t("save")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </Popups>
        </>
    );
}
